"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var dompurify_1 = __importDefault(require("dompurify"));
var AttachFile_1 = __importDefault(require("@mui/icons-material/AttachFile"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var CheckboxComponent_1 = __importDefault(require("../../shared/components/FormComponents/CheckboxComponent"));
var JoinEntity_1 = require("./JoinEntity");
var IconComponent_1 = __importDefault(require("../../shared/components/FormComponents/IconComponent"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var crude_actions_1 = require("../../store/crude/crude.actions");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var getListLabelTemplateContent_1 = __importDefault(require("../../shared/util/getListLabelTemplateContent"));
var crudeHooks_1 = require("../../crudeHooks");
var JoinEntityElement = function (props) {
    var _a, _b;
    var dispatch = react_redux_1.useDispatch();
    var context = react_1.useContext(crudeHooks_1.CrudeContext);
    var crudeHookProps = context.crudeHookProps;
    var TranslationComponent = crudeHookProps && crudeHookProps.translationComponent;
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var crudeLicense = react_redux_1.useSelector(crude_selector_1.getCrudeLicense);
    var extendedTableLicense = crudeLicense.extendedTable.available;
    var elementId = ((_a = props.schema) === null || _a === void 0 ? void 0 : _a.idColumn) && props.data[(_b = props.schema) === null || _b === void 0 ? void 0 : _b.idColumn];
    var maxThumbnails = extendedTableLicense ? appLayout.maxThumbnails : undefined;
    var _c = react_1.useState(true), editReference = _c[0], setEditReference = _c[1];
    var _d = react_1.useState(props.data.selected), checked = _d[0], setChecked = _d[1];
    var _e = react_1.useState(undefined), template = _e[0], setTemplate = _e[1];
    var _f = react_1.useState(false), onlyPositiveBooleans = _f[0], setOnlyPositiveBooleans = _f[1];
    react_1.useEffect(function () {
        // auslesen des Templates, falls vorhanden
        var templateObject = extendedTableLicense && appLayout.entityTemplates && appLayout.entityTemplates.find(function (entityTemplate) { return entityTemplate.name === props.joinEntity; });
        setTemplate(templateObject ? templateObject.template : undefined);
        setOnlyPositiveBooleans(templateObject && templateObject.onlyPositiveBooleans ? templateObject.onlyPositiveBooleans : false);
    }, [props.joinEntity]);
    react_1.useEffect(function () {
        setChecked(props.data.selected);
        // prüfen ob die Beziehung weitere Felder enthält als die pure Zuordnung, ansonsten wird die Büroklammer nicht angezeigt
        var joinEntitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === props.joinEntity; });
        if (joinEntitySchema && joinEntitySchema.columns.length <= 3) {
            setEditReference(false);
        }
    }, [props.data]);
    var newEntityPreviews = props.entityReferencePreviews;
    if (props.joinListType === JoinEntity_1.JoinListType.joinList && props.joinEntityReferencePreviews) {
        newEntityPreviews = props.joinEntityReferencePreviews;
    }
    var labelId = "checkbox-list-label-" + props.key;
    // label nutzt die preview, falls vorhanden, wenn nicht, dann die id
    var listLabel = newEntityPreviews && newEntityPreviews[props.entity] ? newEntityPreviews[props.entity] && newEntityPreviews[props.entity][elementId] : elementId;
    if (template) {
        var templateLabel = crudeSchema && props.schema && crudeLabels && getListLabelTemplateContent_1.default(template, crudeSchema, props.schema, props.data, props.entity, crudeConfig, onlyPositiveBooleans, crudeLabels, props.entityReferencePreviews, props.joinContext, props.thumbnailData, maxThumbnails);
        listLabel = templateLabel || listLabel;
    }
    var handleClickEdit = function (id, entity) { return function () {
        if (props.dataViewType === commonTypes_1.DataViewType.simpleView) {
            if (appLayout.maxTreeViewLevel && typeof (props.treeViewLevel) === 'number' && props.treeViewLevel <= appLayout.maxTreeViewLevel) {
                props.editEntity && props.editEntity({ id: id, entity: entity });
                dispatch(crude_actions_1.setShowDialog(true));
            }
        }
    }; };
    return (react_1.default.createElement(material_1.ListItem, { key: props.key, sx: { MuiListItemSecondaryAction: '164px' }, dense: true },
        react_1.default.createElement(material_1.ListItemIcon, null,
            react_1.default.createElement(CheckboxComponent_1.default, { checked: checked, name: "" + props.key, id: "" + props.key, onChange: function (value) {
                    setChecked(value);
                    props.selectEntity(elementId, value);
                } })),
        react_1.default.createElement(material_1.ListItemText, { id: labelId, primary: (TranslationComponent && (listLabel.indexOf('t(') >= 0))
                ? react_1.default.createElement(TranslationComponent, { expression: listLabel })
                : react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' }, dangerouslySetInnerHTML: { __html: dompurify_1.default.sanitize(listLabel) } }) }),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexWrap: 'noWrap' } },
            (props.joinListType === JoinEntity_1.JoinListType.entityList && props.joinEntityId) && editReference &&
                react_1.default.createElement(IconComponent_1.default, { onClick: handleClickEdit(props.joinEntityId, props.joinEntity), icon: react_1.default.createElement(AttachFile_1.default, null) }),
            react_1.default.createElement(IconComponent_1.default, { onClick: handleClickEdit(elementId, props.entity), icon: react_1.default.createElement(Edit_1.default, null) }))));
};
exports.default = JoinEntityElement;
